export const drawerPaperStyles = {
  borderRadius: '28px 28px 0 0',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderTop: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
  maxHeight: '88vh',
  overflow: 'auto',
};

export const grabberStyles = {
  width: '40px',
  height: '4px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) => palette.action.disabled,
  margin: '8px auto 12px',
};

export const headerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '0 20px 12px',
};

export const subtitleStyles = {
  color: 'text.secondary',
};

export const formStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '0 20px 16px',
};

export const buttonRowStyles = {
  display: 'flex',
  gap: '12px',
  padding: '0 20px',
};

export const skipButtonStyles = {
  flex: 1,
};

export const saveButtonStyles = {
  flex: 1,
};
